<style>
.flow{
    height: 50%;
}
</style>

<template>
    <div class="flow">
        <v-chart :option="option" :init-options="initOptions" ref="flow" autoresize/>
    </div>
</template>

<script>
import * as echarts from "echarts/core";
import { isOpen } from '@/utils/index'
import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 

 const color = ['#0090FF', '#FFC005', '#36CE9E', '#FF515A', '#8B5CFF', '#00CA69']

    const xAxisData = ['11:00','11:30','12:00','12:30', '13:00','13:30','14:00','14:30', '15:00','15:30','16:00','16:30', '17:00','17:30','18:00','18:30','19:00','19:30','20:00','20:30','21:00', '21:30','22:00','22:30','23:00']

    const yAxisData1 = []
    const yAxisData2 = [50, 60, 90, 80, 60, 50, 70]
    const yAxisData3 = [0, 0, 20, 24, 26, 20, 30,32,38,40,36,38,30,28,24,32,38,40,42,36,30,24,0,0,0]

    const hexToRgba = (hex, opacity) => {
        let rgbaColor = ''
        const reg = /^#[\da-f]{6}$/i
        if (reg.test(hex)) {
            rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
        }
        return rgbaColor
    }
    const lineStyle = (index) => {
        return {
            color: color[index],
            shadowColor: hexToRgba(color[index], 0.5),
            shadowBlur: 3,
            shadowOffsetY: 8
        }
    }
    const areaStyle = (index) => {
        return {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [{
                    offset: 0,
                    color: hexToRgba(color[index], 0.3)
                }, {
                    offset: 1,
                    color: hexToRgba(color[index], 0.1)
                }]
            ),
            shadowColor: hexToRgba(color[index], 0.1),
            shadowBlur: 10
        }
    }

export default {
    name: 'Flow',
    data() {
        return {
            initOptions: {
                renderer: 'canvas'
            },
            option: {
                // title: {
                //     text: '顾客类型分布',
                //     subtext: 'Customer type distribution',
                //     left: '20px',
                //     padding: [
                //         5,  // 上
                //         0, // 右
                //         5,  // 下
                //         0, // 左
                //     ],
                //     y: 10,
                //     textStyle: {
                //         color: '#fff',
                //         fontSize: 14
                //     }
                // },
                color: color,
                grid: {
                    top: 25,
                    left: 5,
                    right: 5,
                    bottom: 20
                },
                title: [
                    {
                        text: '实时客流监控',
                        top: 10,
                        left: 10,
                        textStyle: {
                            fontSize: 14,
                            fontWeight: 400,
                            color: '#fff'
                        }
                    }
                ]
                ,
                legend: {
                    icon: 'rect',
                    itemHeight: 12,
                    itemWidth: 12,
                    top: 10,
                    right: 10,
                    textStyle: {
                        fontSize: 12,
                        color: '#567'
                    },
                    data: [
                        {name:'实时客流'},
                        {name: '昨日客流'},
                        {name:'上周客流'}
                    ]
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    extraCssText: 'font-size:14px;line-height:24px;color:#567;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)',
                    formatter: function(params) {
                        let html = ''
                        params.forEach(v => {
                            // console.log(v)
                            html += `<div><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[v.componentIndex]};"></span>${v.seriesName}<span style="color:${color[v.componentIndex]};font-size:18px;font-weight:700">${v.value}</span>人`
                        })
                        return html
                    }
                },
                xAxis: {
                    data: xAxisData
                },
                yAxis: {
                    show: false
                },
                series: [{
                    name: '实时客流',
                    type: 'line',
                    data: yAxisData1,
                    smooth: true,
                    symbolSize: 6,
                    zlevel: 0,
                    lineStyle: lineStyle(0),
                    areaStyle: areaStyle(0)
                }, {
                    name: '昨日客流',
                    type: 'line',
                    data: yAxisData2,
                    smooth: true,
                    symbolSize: 6,
                    zlevel: 0,
                    lineStyle: lineStyle(1),
                    areaStyle: areaStyle(1)
                }, {
                    name: '上周客流',
                    type: 'line',
                    data: yAxisData3,
                    smooth: true,
                    symbolSize: 6,
                    zlevel: 0,
                    lineStyle: lineStyle(2),
                    areaStyle: areaStyle(2)
                },{
                    name: '上周滑行光点',
                    type: 'lines',
                    coordinateSystem: 'cartesian2d',
                    symbolSize: 30,
                    polyline: true,
                    zlevel: 9,
                    z: 2,
                    effect: {
                        show: true,
                        // trailLength: 0,
                        // symbol: "arrow",
                        period: 8, //光点滑动速度
                        trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                        symbol: 'circle', //箭头图标
                        symbolSize: 10,
                        // zlevel: 10,
                        // symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEp0lEQVR42u3cz4sjRRTA8W9Vd3Vn8mMmjj9WQWSRZQ+CsH+B7MnDIgiCd0E8CYJ/gOAIelo8ehUP/gF6WLw5/gMueFP2sIcF0dHd2Z1kknR11fOQZJJJMtlZd03H7HtQpNOTnpn+8Lrm1etmjIig8e/DKoECKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIqoAJudKTr+osZMNPvBUQBHwHsPF9fB9R0DeHMOQ6T6WOrhEzXBM4swDOL0M6CrArRVoq3t2dGUIb9fTvatg8ZZup1PDBgzPmy98mey6qfzjLz2WaWjEUZKEvGyi9nWyneMOvGIyFQo2Sbg4MUSChpU9IeTTUpJdsEajPZOJeJG5uBZj7rLLduWS5dGm6XNLEELOFUFj54ACJCaychkpDSASK3bwsXL0YgVpWJKwM0iy9Zy8HdGru7jvt3Pbu7w0wES7drTwAbjTHMGCsQcIAnYTC1/wRx0wEnl27JNgZI8HQ6Kc1mQq83RNzaMjPzXqDbjTQaJRFLxIyyMSxAXEkWrhrQzAAmo5HOjCQf7jflILxOkohL+aUPgV4vEGNJo+E5PAy02+UIMEwBxo0CPDP7Dg5SnEtpt1PA0e87XO25FOoh8IYIH2Y5b45RzGAQBiIltZoHxqMcjbksXAVgdc2EQMYzzzdotyeZWKuleULXJtwT4SODfC2QCWR+IF9KnjuX1Xbo99Op7LVE8iXlz0YBTk5SyLEEjo5OLuccEoFUvHfO+reuUPx4zftXAIcx1hdcF+/TvFab4A0Bs0VwqyhpVnkJT89/Q4DDQ0e77YCMwIUsFMeFZD856699URRvX4nxE4A/jbnxXp7v4Zw3ReGNSDHI8wFQjIafuoyn58L/fB6sth/Ybg9fez2TRC6QZcZYvgHsazF+MP7YCyLXcM7gvSXLDGBqYDg+NhwdmSpPoTrAkub0W+f4FSB1fDucIunMHSLpO8WAH0rSy8u+19MBCHB4OHzd2pI+CEUhpigEiN+l6WcdY252jLn5s7Wf472ImPcN8pUl/tEHoV4XWq1Ke4KrLmPsTA3oODpytFoOyJKSyzHyMSIxteWngMW5cSEdDJQUhTdZVgxOz3/+jFJm4+bA2e5JpNU6WZ4Fw99JwnWMKccwpeddP+B7GZTNUPKqybJy0O+Hs1YfMz9swwvpB8fbGDG0GuGkkK7V0hxSmZQpABI8l2z0v3sJf50qpAMJCd2qCulql3LD1lRGQjm7lEsDz0rkxTQOfiPPxUBcuJTbbhss/Y1eyi3NwsmKInmkZsKk5gtPUzNhvp11507CSy/X6XYStpvFudpZw1ZWIOF4Cq6SdtbKbioJyAhRTu3u9yMJXerN+ugvaQQsjcZ8Q3VnZwxlSDhe1lB9GjrSw5b+1avT8+Jw+979nNaOI6U3KpTrWAosxVQmygK4ld8X0ZtK/7eViExD7O1NQPb3T7fsl4/4sBpwYzPwjFbTo95Yl9l9Vd1YN1X/147HebSjary1AHyc5qc+XLQEQx9ve8Kg6xr6hKoCKqACKqCGAiqgAiqghgIqoAIqoIYCKqACKqCGAiqgAiqghgIq4JrHP8fEWV8FMTmOAAAAAElFTkSuQmCC'
                    },
                    lineStyle: {
                        width: 1,
                        opacity: 0.6,
                        curveness: 1,
                        color: color[2],
                        shadowColor: hexToRgba(color[2], 0.5),
                        shadowBlur: 3,
                        shadowOffsetY: 8
                    },
                    areaStyle: areaStyle(0),
                    data: yAxisData1
                },{
                    name: '昨天滑行光点',
                    type: 'lines',
                    coordinateSystem: 'cartesian2d',
                    symbolSize: 30,
                    polyline: true,
                    zlevel: 9,
                    z: 2,
                    effect: {
                        show: true,
                        period: 8, //箭头指向速度，值越小速度越快
                        trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                        symbol: 'circle', //箭头图标
                        symbolSize: 10, //图标大小
                        // zlevel: 10,
                        // symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABPCAYAAACqNJiGAAAACXBIWXMAAAsSAAALEgHS3X78AAAGS0lEQVR42u2cz4skSRXHPy8iMrOrq7qnp3dqloEeD0PvHrbxB/TJkwt6EGVBwRHUf0BPXj146JPgosJe/PEX6NoHYUUE8bCC11ZQtw+DLMq2DtPlbM9MVXVVZkbE85DVXdU97e6yi1U9TXwhyaIq4lXmh29ERrxXlKgqSR9OJiFI8BK8BC/BS0rwErwEL8FLSvASvAQvwUvwkhK8BC/BS/CSErwEL8FL8JISvI8udxkvShA5/55y+QrMchmK3hfBej9dBpgLhXcBNIGd9+ix03C7JBAXBm8GnEzBvDV53bvAid3JhW7pDGBdJMC5wzvnNoG7U2B7fWF7G/aPhJdmWu0DL11X9vZge0WnIHd11onzhrgoeDJ1Wk/gRYEjgYHA88LBUNiY6XQAbLQVHih0FK4r3JtAPHWizhueWYzrZsDtdw28Y6BtKJfbVHWbDSzvxg5la413Y4cNLFXdZtxepV4q4B3T9OtJE2fnQz94ngnnzYCTqeO6DbT7Dw1uyZBlHTreM3QBqacgNFPa3jJwjhg85fExt56LMIzQizMOnOscOO9F8tPgyv4ymVi6WExdMbJgbYZ1GSU51mVYmzGyYOqK9ViTiaXsL0PbNHFOHIhcuWF7drhCM8cNhLK/zBCLW7fQcqegqphjNMfRnKuYnwKl5XDrliETgIPJnDmNP6/hO+cdxonrEOgYCipGtcOWjqF3mJal9A6Lxahg7QZB1nB6RKX/pMg8w5FgnUCoKTIPHQNHOnHfU+vAKzJsd+SM6x48NpAb1jKDwVLmjljfJONFRL5CaX8A5tcQ7yHmAS2TIVVGmTsMlrWs6f/gsTnnPrmC8IA3e8L+UbMcydfbPBoaBlhELctqCTJAwwHoZ4BPA6/hydH4I8rwDSqzRaE3ELUMsDwaGvL1NjzfxH2zd7XmvDPzz8vQLH6HgpYekxnEGcZYZAJRnCPG7+L44nf4wgG5dcBfQL4M+hDlVtPeGUxm0NLDsFlUv/zR9suXP6vy94HQdkKx6pHjDBCWW4IPn0D5JF7/+Cn5WPx++OrPWpK/8Pnw8cFr/O7rv4p/fh1nKjL5D84JYSSIF1iuuf9EGHph86rm83bfusAJKyCFgBeCCvBNNB5/y3z2lRb5C80FSudLsv0KRIEolLFpL4XAygf8nmcd3t0tPTeeLQDHwBiAv2H0c2RmNJbqyWzTUuo+mVGi/B5YYzzpd6K8aP/P77lCi2TY7ExvTkeKlorWCkbBRdD4bfP6G//i0S8GjP/Uo/+bn8gf3gCNID8FbqL1pN+oiRVCdSbunLSYTHJYUkLfYzqOlo1UMYJuEilBfgjht1+LP34VcYJ6JWjEmYDYnxO1RiXSMpEQlNhXqqJexG383513dp/ZbTIivq3cuBaJdUR9JEog+vsQIvBLkC2c1kStMeZ7GPsqUe6g9S3iOBAlNP3qyI1rEd+eZFq6c01PzSUxME1D3RX23jZs3zQ8bK+y0oZR7bGFYzzKsLnDeIcYg9QGMoFaUXsLWCaaf+N9j6VWTSg9rczRH8JzwyfsHUa278STHN884M1zzmsyH9sryn5HWW2N6fvINQnEQSBkniLW5FKhsUU0N1G/SZCKyD/I5K/kHBIyTxwErkmg7yOrrTH7nSYuWzrP7dk8ncdZ990RDrAUWLq5AbX01WKwjKxh2U+XHMdOaYVIJLAiASTQqyIlgQ0Ce2/rrOvmNWzNfCx3eiMT992JcF0ZDxoANQ6fC6HwBF9TmIog06MwFcHXhMLjc6GkoCQwHjRxtu/EWddd1XxekzbaBbinbN6OjAeRLDsm9KEeelZXalZCjffTYyXUrK7U1ENP6IMxY8aDyObtCPe0ibdz9Z62F7rv7q6y21U4ijy+3WSEi+Mh3banHkI5dmheUC15qiXPuCyoh0K37SmOh2Tjsul3FNntNvEWUElbZPXs6SLQadVscMEWq6OnVbQLij/zBreQYXt2/ttRmHHhYW9SkxgF9g4jHMbmPArQm3w+cRu7JzWLhdVuL0PRm7NOPMk4n9fJnnXnqWzxwn41oKoLPVDkwmMHg2Im5wvbLPra5TL9u8UHSWBepl9LSfprkGdqnZfgJSV4CV6Cl+AleEkJXoKX4CV4SQlegpfgJXgJXlKCl+AleAleUoKX4CV4V0//BfBm5Ekg9qBkAAAAAElFTkSuQmCC'
                    },
                    lineStyle: {
                        width: 1,
                        opacity: 0.6,
                        curveness: 1,
                        color: color[1],
                        shadowColor: hexToRgba(color[1], 0.5),
                        shadowBlur: 3,
                        shadowOffsetY: 8
                    },
                    areaStyle: areaStyle(1),
                    data: yAxisData1
                },{
                    name: '今天滑行光点',
                    type: 'lines',
                    coordinateSystem: 'cartesian2d',
                    symbolSize: 30,
                    polyline: true,
                    zlevel: 9,
                    z: 2,
                    effect: {
                        show: true,
                        period: 8, //箭头指向速度，值越小速度越快
                        trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                        symbol: 'circle', //箭头图标
                        symbolSize: 10, //图标大小
                        // zlevel: 10,
                        // symbol: 'image://data:image/png;base64,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'
                    },
                    lineStyle: {
                        width: 1,
                        opacity: 0.6,
                        curveness: 1,
                        color: color[0],
                        shadowColor: hexToRgba(color[0], 0.5),
                        shadowBlur: 3,
                        shadowOffsetY: 8
                    },
                    areaStyle: areaStyle(0),
                    data: yAxisData1
                }
                ]
            }
        }
    },
    mounted() {
        // console.log('客流')
        // console.log(xAxisData.length)
        // let lastweek = []
        let lastday = []
        let today = []
        let lines  = [{
                coords:[]
            }]
        let lines2  = [{
                coords:[]
            }]
        // let i = 0
        // let i2 = 0
        // // let i3 = 0
        for (let index = 0; index < xAxisData.length; index++) {
        //    console.log(1)
            if(index<2) {
                lastday.push((this.option.series[2].data[index]+this._.random(0,1)))
                // lastday.push(this._.random(0+i,5))
                // i++
            }
            if(index>=2&&index<20) {
                lastday.push((this.option.series[2].data[index]+this._.random(2,8)))
            }
            
            if(index>=20){
                lastday.push((this.option.series[2].data[index]+this._.random(0,5)))
            }
        }

        // this.option.series[2].data= lastweek
        this.option.series[1].data= lastday
        let opentime = moment({hour: 11, minute: 0});
            let endtime = moment({hour: 23, minute: 0});
            let k = 0
            let nowdate = moment();
            while(isOpen()&&nowdate.isSameOrAfter(opentime)&&nowdate.isSameOrBefore(endtime)){
                today.push((this.option.series[1].data[k]+this._.random(0,10)))
                k++
                opentime.add(30,'minutes')
            }
            for (let index = 0; index < xAxisData.length; index++) {
                if(index>k){
                    today.push(0)
                }
            }
            for (let aindex = 0; aindex < today.length; aindex++) {
                lines[0].coords[aindex] = []
                lines[0].coords[aindex].push(xAxisData[aindex])
                lines[0].coords[aindex].push(yAxisData3[aindex])
                lines2[0].coords[aindex] = []
                lines2[0].coords[aindex].push(xAxisData[aindex])
                lines2[0].coords[aindex].push(lastday[aindex])
            }
            // console.log(lines)
            let lines3 = this.loopdata(today)
            setInterval(()=>{
                nowdate = moment();
                if(isOpen()&&nowdate.isSameOrAfter(opentime)&&nowdate.isSameOrBefore(endtime)){
                    today[k] = (this.option.series[1].data[k]+this._.random(2,10))
                    this.option.series[5].data[0].coords[k][1] = today[k]
                    k++
                    opentime.add(30,'minutes')
                }
                // lines3 = this.loopdata(today)
            },3000)
            this.option.series[0].data = today
            this.option.series[3].data = lines
            this.option.series[4].data = lines2
            this.option.series[5].data = lines3
    },
    methods: {
        loopdata(today=[]) {
            let todayline = [{
                coords:[]
            }]
            for (let index = 0; index < today.length; index++) {
                todayline[0].coords[index] = []
                todayline[0].coords[index].push(xAxisData[index])
                todayline[0].coords[index].push(today[index])
            }
            console.log(todayline)
            return todayline
        }
    }
}
</script>
